import React from 'react';
import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import { Separator, Text } from '@cuemath/web-comps';
import BallLoader from 'comps/ball-loader';

import { useTeacherLicenseGet } from 'actions/teacher-license';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import { POCHeading } from 'screens/student-details/styled-comps';

const StyledCol2 = styled(Col)`
  flex: 2;
`;

const CourseInfoHeading = styled(Text)`
  color: rgba(43, 43, 43, 0.75);
  line-height: 20px;
  cursor: ${({ cursor }) => (cursor ? cursor : 'default')};
  width: ${({ width }) => (width ? width : 'auto')};
  flex: 1;
`;

const CustomRow = styled(Row)`
  flex-wrap: nowrap;
  gap: 40px;
`;

const POCValue = styled(Text)`
  text-transform: capitalize;
  color: #2b2b2b;
  text-decoration: ${({ textDecoration }) => (textDecoration ? textDecoration : 'none')};
  cursor: ${({ textDecoration }) =>
    textDecoration === 'underline' ? 'pointer' : 'default'};
`;

const getFormat = min => {
  return min === 0 ? 'ddd, ha' : 'ddd, h:mma';
};

const formattedHoursText = slot => {
  const { start_ts: startTimestamp, end_ts: endTimestamp } = slot || {};
  const startDate = moment.unix(startTimestamp);
  const endDate = moment.unix(endTimestamp);
  const startMinutes = startDate.minutes();
  const endMinutes = endDate.minutes();
  const isNextDay = startDate.date() < endDate.date();
  const endFormatWithoutDay = endMinutes === 0 ? 'ha' : 'h:mma';
  const endDateFormat = isNextDay ? getFormat(endMinutes) : endFormatWithoutDay;

  return `${startDate.format(getFormat(startMinutes))} - ${endDate.format(
    endDateFormat,
  )}`;
};

const TrialPreference = () => {
  const { teacherId } = useParams();
  const {
    get: getTeacherLicense,
    data,
    isProcessing: isTeacherLicenseLoading,
  } = useTeacherLicenseGet(teacherId, { with_license_preferences: true });

  const { preferences } = data || {};

  const {
    availability_schedule: avaliablities,
    growth_preference_enabled: growthPrefEnabled,
  } = preferences || {};

  useEffect(() => {
    getTeacherLicense(teacherId, { with_license_preferences: true });
  }, [getTeacherLicense, teacherId]);

  if (isTeacherLicenseLoading) {
    return (
      <FlexView>
        <Separator height={48} />
        <BallLoader />
      </FlexView>
    );
  }

  return (
    <>
      <>
      <POCHeading variant="eyebrow1">Available hours</POCHeading>
      <Separator height={8} />
      {avaliablities?.length ? (
        avaliablities.map((item, index) => {
          const text = formattedHoursText(item);

          return (
            <CustomRow gap={4}>
              <CourseInfoHeading variant="eyebrow2">SLOT {index + 1}</CourseInfoHeading>
              <StyledCol2>
                <POCValue variant="body1Medium">{text}</POCValue>
              </StyledCol2>
            </CustomRow>
          );
        })
      ) : (
        <CustomRow gap={4}>
          <StyledCol2>
            <POCValue variant="body1Medium">Availability has not been added yet.</POCValue>
          </StyledCol2>
        </CustomRow>
      )}
      <Separator height={32} />
    </>


      <POCHeading variant="eyebrow1">Growth Preference</POCHeading>
      <Separator height={8} />
      <CustomRow gap={4}>
        <CourseInfoHeading variant="eyebrow2"> ADD MORE STUDENTS</CourseInfoHeading>
        <StyledCol2>
          <POCValue variant="body1Medium">{growthPrefEnabled ? 'Yes' : 'No'}</POCValue>
        </StyledCol2>
      </CustomRow>
    </>
  );
};

export default TrialPreference;
